import {useState, useEffect, useCallback} from 'react';

const STORAGE_KEY = 'jsonvisual:theme';

// Resolve the initial theme: an explicit saved choice wins; otherwise the app
// defaults to dark mode.
const getInitial = () => {
    try {
        const saved = window.localStorage.getItem(STORAGE_KEY);
        if (saved === 'light') return false;
        if (saved === 'dark') return true;
    } catch (e) { /* storage unavailable */ }
    return true;
};

// Manages dark-mode state: persists the choice and reflects it as a
// `dark-mode` class on <body> so global CSS can theme the whole page.
const useDarkMode = () => {
    const [dark, setDark] = useState(getInitial)

    useEffect(() => {
        document.body.classList.toggle('dark-mode', dark)
        try {
            window.localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light')
        } catch (e) { /* ignore */ }
    }, [dark])

    const toggle = useCallback(() => setDark(d => !d), [])

    return [dark, toggle]
}

export default useDarkMode;
